import React from 'react';
import { Grid, Link, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import { routes } from 'utils/routing';

import Logo from 'components/common/Logo';
import Image from 'components/common/Image';

interface IProps {
  disabled?: boolean;
  organization: any;
}

const useStyles = makeStyles()((theme) => ({
  organizedBy: {
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: 4,
  },
  logoItem: {
    padding: theme.spacing(1),
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.custom.border.gray}`,
    boxShadow: 'none',
  },
}));

const EventOrganization: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { disabled, organization } = props;
  const { classes } = useStyles();
  const [t] = useTranslation('public');

  return (
    <Link
      color="inherit"
      underline="none"
      {...(disabled
        ? { component: 'div' }
        : { target: '_blank', href: routes.organizationProfile(organization.id).link })}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="center" wrap="nowrap">
        {organization.logo && (
          <Grid item>
            <Logo className={classes.logoItem} xs={64} sm={64} md={64}>
              <Image src={organization.logo} alt={organization.title} />
            </Logo>
          </Grid>
        )}
        <Grid item>
          <Typography className={classes.organizedBy} variant="body2" color="textSecondary" component="p">
            {t<string>('event.eventOrganization')}
          </Typography>
          <Typography variant="subtitle2" color={disabled ? 'textSecondary' : 'primary'}>
            {organization.title}
          </Typography>
        </Grid>
      </Grid>
    </Link>
  );
};

export default EventOrganization;
